import ZipmapRepository from "../../repository/ZipmapRepository"
import { useState, useEffect } from "react"
import MemberItem from "../member/MemberItem"
import PendingMemberItem from "../member/PendingMemberItem"

export default function DashboardPageMembers({ viewingMap }) {

    const [loadingText, setLoadingText] = useState(null)
    const [members, setMembers] = useState([])
    const [pendingMembers, setPendingMembers] = useState([])
    const [inviteeEmail, setInviteeEmail] = useState("")
    const [toastMessage, setToastMessage] = useState(null)
    const [fullScreenLoadingText, setFullScreenLoadingText] = useState(null)

    useEffect(() => {

        async function getMapMembers(slug) {
            setLoadingText("Loading ...")
            const zipmapRepository = new ZipmapRepository()
            const mapMembersResponse = await zipmapRepository.getMapMembers(slug)
            console.log(mapMembersResponse)
            setMembers(mapMembersResponse.members)
            setPendingMembers(mapMembersResponse.pendingInvitations.map((pendingInvitation) => {
                return pendingInvitation.invitedUserId
            }))
            setLoadingText(null)
          }

          getMapMembers(viewingMap.slug)

    }, [viewingMap])

    useEffect(() => {
        if (toastMessage) {
            setTimeout(() => {
                setToastMessage(null)
            }, 3000)
        }
    }, [toastMessage])

    async function inviteMapMember(slug, email) {
        setFullScreenLoadingText("Inviting ...")
        const zipmapRepository = new ZipmapRepository()
        await zipmapRepository.inviteMapMember(slug, email)
        setPendingMembers([...pendingMembers, email])
        setFullScreenLoadingText(null)
        setToastMessage({
            message: `🎉 ${email} invited successfully`,
            type: "success"
        })
      }

    function onInviteeEmailInputChange(event) {
        setInviteeEmail(event.target.value)
    }

    function onInviteClick() {
        inviteMapMember(viewingMap.slug, inviteeEmail)
    }

    return (
        <div className="h-full flex flex-col flex-1 py-4 bg-base-200">
            <div className="font-bold text-base py-4 flex items-center px-4">
                <span>Invite a new member</span>
            </div>
            <div className="flex w-full gap-2 px-4 pb-4">
                <div className="form-control flex-1 relative flex flex-row items-center gap-4">
                    <input className={`input input-bordered flex-1 rounded-md z-1`} value={inviteeEmail} placeholder={"Enter email here to invite ..."} onChange={onInviteeEmailInputChange} type="email" />
                    <button className="btn btn-primary normal-case" onClick={onInviteClick}>Send</button>
                </div>
            </div>
            {
                loadingText && <div className="flex justify-center items-center h-full flex flex-row gap-2 py-4">
                    <span className="loading loading-spinner text-primary"></span>
                    {loadingText}
                </div>
            }
            {
                members.map((member) => {
                return MemberItem(
                    member, () => {
                    }
                )
                })
            }
            {
            pendingMembers.map((pendingMember) => {
              return PendingMemberItem(pendingMember)
            })
          }
          {
                toastMessage && <div className="toast z-10">
                <div className={`alert ${toastMessage.type == "success" ? "alert-success" : "alert-info"}`}>
                <span className="text-sm">{toastMessage.message}</span>
                </div>
            </div>
          }
          {
                fullScreenLoadingText &&
                <div className='w-full h-screen absolute max-w-[100%] top-0 flex flex-row items-center justify-center gap-2 backdrop-blur-sm bg-base-100/30 z-50'>
                    <div className="loading loading-infinity loading-lg"></div>
                    <div className='font-normal text-base-content'>{fullScreenLoadingText}</div>
                </div>
            }
        </div>
    )
}